module.exports = __webpack_public_path__ + "static/media/rectangle.61867cc6.jpg";